import React from "react";
import { withJsonFormsEnumProps, withTranslateProps } from "@jsonforms/react";
import { isEnumControl, rankWith } from "@jsonforms/core";

export const materialEnumControl = (props) => {
  if (!props.visible) {
    return null;
  }

  return (
    <>
      <strong>{props.label}:</strong>&nbsp;
      {props.options.find((option) => option.value === props.data)?.label}
    </>
  );
};

export const materialEnumControlTester = rankWith(3, isEnumControl);

export default withJsonFormsEnumProps(
  withTranslateProps(React.memo(materialEnumControl)),
  false,
);
